













































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Skills extends Vue {
  skillColor="#008c99";//"#00def2";

  programmingSkills = [
    {
      level: 8,
      name: 'PHP',
    },
    {
      level: 6,
      name: 'Java',
    },
    {
      level: 7,
      name: 'JavaScript',
    },
    {
      level: 6,
      name: 'NodeJS',
    },
    {
      level: 8,
      name: 'SQL',
    },
    {
      level: 7,
      name: 'HTML5',
    },
    {
      level: 6,
      name: 'CSS',
    },
    {
      level: 8,
      name: 'SCSS',
    },
  ];

  frameworkSkills = [
    {
      level: 8,
      name: 'Laravel',
    },
    {
      level: 8,
      name: 'VueJs',
    },
    {
      level: 8,
      name: 'Vuex',
    },
    {
      level: 8,
      name: 'Axios',
    },
    {
      level: 6,
      name: 'Docker',
    },
    {
      level: 6,
      name: 'Git',
    },
    {
      level: 5,
      name: 'Hibernate',
    },
    {
      level: 4,
      name: 'Maven',
    },
  ];

  systemSkills = [
    {
      level: 5,
      name: 'Amazon AWS',
    },
    {
      level: 6,
      name: 'Bitbucket',
    },
    {
      level: 6,
      name: 'Jira',
    },
    {
      level: 8,
      name: 'Slack',
    },
    {
      level: 8,
      name: 'Google G Suite',
    },
    {
      level: 4,
      name: 'Photoshop',
    },
    {
      level: 6,
      name: 'iMovie',
    },
    {
      level: 7,
      name: 'Mailchimp',
    },
  ];

  managementSkills = [
    {
      level: 8,
      name: 'SCRUM',
    },
    {
      level: 8,
      name: 'Kanban',
    },
    {
      level: 7,
      name: 'Google OKRs',
    }
  ];

  languageSkills = [
    {
      level: 8,
      name: 'German',
    },
    {
      level: 7,
      name: 'English',
    },
    {
      level: 2,
      name: 'Spanish',
    }
  ];
}
